/**
 * Admin Customer Accounts Page
 * Financial account management for administrators
 */

import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@spcc/core'
import { CustomerAccountsSection } from '@spcc/domains/customer-accounts'

export const Route = createFileRoute('/admin/customer-accounts')({
  component: CustomerAccountsPage,
})

function CustomerAccountsPage() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">
          {t('customerAccounts.title', 'Customer Accounts')}
        </h1>
        <p className="text-muted-foreground mt-1">
          {t('customerAccounts.subtitle', 'Manage customer financial accounts and credit limits')}
        </p>
      </div>
      <CustomerAccountsSection />
    </div>
  )
}
